// StockPeersCardSkeleton.js
import React from "react";
import { Skeleton } from "@heroui/skeleton";

const StockPeersCardSkeleton = () => {
  return (
    <div
      className="relative bg-E6E6E6 shadow-sm rounded-xl p-2 justify-between h-350 mb-4"
      style={{ width: "250px" }}
    >
      <div className="flex mt-2 justify-between items-start">
        <div className="flex items-center">
          <Skeleton className="h-10 w-10 rounded-full" />
          <div className="ml-2">
            <Skeleton className="h-4 w-16 mb-1" />
            <Skeleton className="h-3 w-24" />
          </div>
        </div>
        <div className="text-right pr-5 pt-1">
          <Skeleton className="h-4 w-16 mb-1" />
          <Skeleton className="h-4 w-16" />
        </div>
      </div>
      <div className="flex-grow p-2 ">
        {[...Array(6)].map((_, index) => (
          <Skeleton key={index} className="h-4 w-full mt-2" />
        ))}
      </div>
    </div>
  );
};

export default StockPeersCardSkeleton;
